import { OUTPUT_OPERATION_FIELDS, prodOpCreateReq, prodOpOutputReq } from '@gtpl/shared-models/production-management';
import { Button, Card, Col, Form, message, Row, Select, Table,Input, Modal, DatePicker } from 'antd'
import { ColumnProps } from 'antd/lib/table';
import { ProdlogService } from 'libs/shared-services/production/src/lib/prod-log.service';
import React, { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import { ArrowRightOutlined } from '@ant-design/icons';
import { ProductService, SkuService } from '@gtpl/shared-services/masters';
import { countTypeEnum, DeheadingReportingTypeEnum } from '@gtpl/shared-models/common-models';
import Highlighter from 'react-highlight-words';
import { SearchOutlined } from '@ant-design/icons';
import { RmCountPriceListService } from '@gtpl/shared-services/raw-material-procurement';
import { EditOutlined, DeleteOutlined, PlusOutlined } from '@ant-design/icons';

const SpsaProductionOperationsGrid = () => {
  const prodLogService=new ProdlogService();
  const [prodOpInputData,setProdOpInputData]=useState<any[]>([])
  const [page, setPage] = React.useState(1);
  const { Option } = Select;
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [form] = Form.useForm();
  const [variants,setVariants] = useState<any[]>([])
  const variantService = new ProductService()
    const plantId=Number(localStorage.getItem("unit_id"));
  const createdUser=JSON.parse(localStorage.getItem('username'));
      const [searchText, setSearchText] = useState('');
      const [searchedColumn, setSearchedColumn] = useState('');
      const searchInput = useRef(null);
      const [operation,setOperation]= useState<any[]>([])
       const [prevOperation,setPrevperation]= useState<any[]>([])
        const [lotNumber,setLotNumber]= useState<any[]>([])
        const [counts,setCounts]=useState<any[]>([])
        const rmservice=new RmCountPriceListService()
        const [filteredCounts, setFilteredCounts] = useState<any[]>([]);
const [filterForm] = Form.useForm();
  const service = new SkuService;
  const [outputGridData, setOutputGridData] = useState<any[]>([]);
const [editIndex, setEditIndex] = useState<number | null>(null);

  useEffect(()=>{
    getProdOpInputData();
    getVariants()
    getOperationForInputProd()
    getPrevOperationForInputProd()
    getLotForInputProd()
    getAllProductCount()
  },[])

     const getOperationForInputProd = () => {
      prodLogService.getOperationForInputProd().then(res => {
        if(res.status){
          setOperation(res.data)
        }else{
          setOperation([])
        }
      })
    }

       const getPrevOperationForInputProd = () => {
      prodLogService.getPrevOperationForInputProd().then(res => {
        if(res.status){
          setPrevperation(res.data)
        }else{
          setPrevperation([])
        }
      })
    }

       const getLotForInputProd = () => {
      prodLogService.getLotForInputProd().then(res => {
        if(res.status){
          setLotNumber(res.data)
        }else{
          setLotNumber([])
        }
      })
    }

    const getAllProductCount = () => {
      rmservice.getAllProductCount().then(res => {
        if(res.status){
          setCounts(res.data)
        }else{
          setCounts([])
        }
      })
    }

   const getVariants = () => {
       service.getAllSku().then(res => {
        if(res.status){
          setVariants(res.data)
        }else{
          setVariants([])
        }
      })
    }

  const getProdOpInputData=()=>{
    const req=new prodOpCreateReq();
    if(filterForm.getFieldValue('filterOperation')){
      req.operation=filterForm.getFieldValue('filterOperation')
    }
    if(filterForm.getFieldValue('filterPrevOperation')){
      req.prevOperation=filterForm.getFieldValue('filterPrevOperation')
    }
        if(filterForm.getFieldValue('filterLotNumber')){
      req.lotNumber=filterForm.getFieldValue('filterLotNumber')
    }
    prodLogService.getProdOpInputData(req).then((res)=>{
      if(res.status){
        setProdOpInputData(res.data)
      }else{
        setProdOpInputData([])
        message.error('No Production Operation Data Found');
      }
    })
  }

    const calculateYield = () => {
    const input = Number(selectedRow?.inputQuantity || 0);
    const output = Number(form.getFieldValue('quantity') || 0);

    if (!input) return 0;
    return ((output / input) * 100).toFixed(2);
  };

    const openModal = (record: any) => {
    setSelectedRow(record);
    setModalVisible(true);
    form.resetFields();
setFilteredCounts([]);
setOutputGridData([]);
setEditIndex(null);  
};

const onAddOutputData = () => {

  form.validateFields([
    'quantity',
    'outputProduct',
    'count',
    'countType',
    'reportingType'
  ]).then(values => {

    const selectedProduct = variants.find(
      v => v.skuCodeId === values.outputProduct
    );

    const selectedCount = filteredCounts.find(
      c => c.count === values.count
    );
    const alreadyFullExists = outputGridData.some(
  item => item.reportingType === 'FULL'
);

if (
  alreadyFullExists &&
  editIndex === null
) {

  message.error(
    'Full reporting already completed. Cannot add more entries'
  );

  return;
}

    // const duplicate = outputGridData.some((item, index) => {

    //   if (editIndex !== null && index === editIndex) {
    //     return false;
    //   }

    //   return (
    //     item.outputProduct === values.outputProduct &&
    //     item.count === values.count &&
    //     item.countType === values.countType
    //   );
    // });

    // if (duplicate) {
    //   message.error(
    //     'Same Product + Count + Count Type already added'
    //   );
    //   return;
    // }

    const currentQty = Number(values.quantity || 0);

const existingTotal = outputGridData.reduce((sum, item, index) => {

  if (editIndex !== null && index === editIndex) {
    return sum;
  }

  return sum + Number(item.quantity || 0);

}, 0);

const finalTotal = existingTotal + currentQty;

const balanceQty = Number(selectedRow?.balanceQty || 0);
const availableQty = balanceQty - existingTotal;

if (currentQty > availableQty) {

  message.error(
    `Total output quantity cannot exceed remaining quantity (${availableQty})`
  );

  return;
}

    const rowData = {
      quantity: Number(values.quantity),
      outputProduct: values.outputProduct,
      outputProductName: selectedProduct?.shortCode,
      count: values.count,
      countName: selectedCount?.count,
      countType: values.countType,
      reportingType: values.reportingType,
    };

    if (editIndex !== null) {

      const updated = [...outputGridData];
      updated[editIndex] = rowData;

      setOutputGridData(updated);

      message.success('Updated successfully');

      setEditIndex(null);

    } else {

      setOutputGridData([
        ...outputGridData,
        rowData
      ]);

      message.success('Added successfully');
    }

    form.setFieldsValue({
      quantity: undefined,
      outputProduct: undefined,
      count: undefined,
      countType: undefined,
      reportingType: undefined,
      yield: undefined
    });

    setFilteredCounts([]);
  });
};

const onEditRow = (record, index) => {

  setEditIndex(index);

  getCountsByProduct(record.outputProduct);

  form.setFieldsValue({
    quantity: record.quantity,
    outputProduct: record.outputProduct,
    count: record.count,
    countType: record.countType,
    reportingType: record.reportingType,
    yield: (
      (Number(record.quantity) /
        Number(selectedRow?.inputQuantity || 0)) * 100
    ).toFixed(2)
  });
};

const onDeleteRow = (index) => {

  const filtered = outputGridData.filter(
    (_, i) => i !== index
  );

  setOutputGridData(filtered);

  message.success('Deleted successfully');
};

const outputColumns: ColumnProps<any>[] = [
  {
    title: 'S.No',
    render: (_, __, index) => index + 1
  },
  {
    title: 'Product',
    dataIndex: 'outputProductName'
  },
  {
    title: 'Quantity',
    dataIndex: 'quantity',
    render: (value) => Number(Number(value).toFixed(2))
  },
...(OUTPUT_OPERATION_FIELDS[selectedRow?.operation?.toUpperCase()]?.some(
  f => f.name === 'count'
)
  ? [
      {
        title: 'Count',
        dataIndex: 'countName'
      }
    ]
  : []),

...(OUTPUT_OPERATION_FIELDS[selectedRow?.operation?.toUpperCase()]?.some(
  f => f.name === 'countType'
)
  ? [
      {
        title: 'Count Type',
        dataIndex: 'countType'
      }
    ]
  : []),
  {
    title: 'Reporting Type',
    dataIndex: 'reportingType'
  },
  {
    title: 'Action',
    render: (_, record, index) => {
      return (
        <>
          <EditOutlined
            style={{
              color: '#1890ff',
              marginRight: 12,
              cursor: 'pointer'
            }}
            onClick={() => onEditRow(record, index)}
          />

          <DeleteOutlined
            style={{
              color: 'red',
              cursor: 'pointer'
            }}
            onClick={() => onDeleteRow(index)}
          />
        </>
      );
    }
  }
];

  const handleSubmit = async (values) => {
    if (!values?.date) {

  message.error('Please Select Output Date');

  return;
}
    console.log("Output Submit:", values, selectedRow);
    if (outputGridData.length === 0) {
    message.error('Please add atleast one output item');
    return;
  }

  const totalQty = outputGridData.reduce(
    (sum, item) => sum + Number(item.quantity || 0),
    0
  );

  const balanceQty = Number(selectedRow?.balanceQty || 0);

  if (totalQty > balanceQty) {

    message.error(
      `Total output quantity cannot exceed remaining quantity (${balanceQty})`
    );

    return;
  }
   try {
    // let res;
const gridData = [...outputGridData];

const totalQty = gridData.reduce(
  (sum, item) => sum + Number(item.quantity || 0),
  0
);

const balanceQty = Number(selectedRow?.balanceQty || 0);

if (totalQty === balanceQty) {

  const lastIndex = gridData.length - 1;

  if (
    lastIndex >= 0 &&
    gridData[lastIndex]?.reportingType?.toUpperCase() === 'PARTIAL'
  ) {

    gridData[lastIndex] = {
      ...gridData[lastIndex],
      reportingType: 'FULL'
    };

    message.warning(
      'Complete remaining quantity has been reported. Reporting Type of the last record has been automatically changed from PARTIAL to FULL.'
    );
  }
}


console.log("FINAL GRID", gridData);
let successCount = 0;

const payload: any[] = [];

for (const item of gridData) {

  const selectedVariant = variants.find(
    v => v.skuCodeId === item.outputProduct
  );

  const req = new prodOpOutputReq();

  req.operation = selectedRow.operation;
  req.prevOperation = selectedRow.prevOperation;
  req.lotNumber = selectedRow.lotNumber;
  req.plantId = plantId;
  req.date = values.date?.toISOString();;

  req.createdUser = createdUser;
  req.quality = selectedRow.quality;
  req.prodInvId = selectedRow.prodInvId;
  req.productionLogId = selectedRow.productionLogId;
  req.remarks = selectedRow.remarks;

  req.inputQuantity = selectedRow.inputQuantity;
  req.inputCount = selectedRow.count;
  req.inputCountType = selectedRow.countType;

  req.variantId = item.outputProduct;
  req.variantName = selectedVariant?.shortCode;

  req.outPutQuantity = item.quantity;

  req.count = item.count;
  req.countType = item.countType;

  req.reportingType = item.reportingType;

  payload.push(req);
}

console.log("FINAL PAYLOAD", payload);

const res = await prodLogService.createOutputProdOp(payload);

console.log("FINAL API RESPONSE", res);

if (res?.status) {

  message.success('Production O/P Captured successfully');

  setModalVisible(false);

  form.resetFields();

  setOutputGridData([]);

  setEditIndex(null);

  getProdOpInputData();

} else {

  message.error(res?.internalMessage || 'API Failed');
}

if (successCount === gridData.length) {

  message.success('Production O/P Captured successfully');

  setModalVisible(false);

  form.resetFields();

  setOutputGridData([]);

  setEditIndex(null);

  getProdOpInputData();

} else if (successCount > 0) {

  message.warning(
    `${successCount} of ${gridData.length} records created`
  );

} 

  } catch (err) {

    message.error('Something went wrong');
  }
 
};



          function handleSearch(selectedKeys, confirm, dataIndex) {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
    };
    function handleReset(clearFilters) {
        clearFilters();
        setSearchText('');
    };
    const getColumnSearchProps = (dataIndex: string) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={searchInput}
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Button
                    type="primary"
                    onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                    icon={<SearchOutlined />}
                    size="small"
                    style={{ width: 90, marginRight: 8 }}
                >
                    Search
                </Button>
                <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                    Reset
                </Button>
            </div>
        ),
        filterIcon: filtered => (
            <SearchOutlined type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
        ),
        onFilter: (value, record) =>
            record[dataIndex]
                ? record[dataIndex]
                    .toString()
                    .toLowerCase()
                    .includes(value.toLowerCase())
                : false,
        onFilterDropdownVisibleChange: visible => {
            if (visible) { setTimeout(() => searchInput.current.select()); }
        },
        render: text =>
            text ? (
                searchedColumn === dataIndex ? (
                    <Highlighter
                        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                        searchWords={[searchText]}
                        autoEscape
                        textToHighlight={text.toString()}
                    />
                ) : text
            ) : null
    });

  const Columns: ColumnProps<any>[]  =[
    {
      title: 'S No',
                key: 'sno',
                width: '70px',
                align: 'left',
                responsive: ['md'],
                render: (text, object, index) => (page - 1) * 10 + (index + 1)
    },
    {
        title: 'Date',
        dataIndex: 'date',
        sorter: (a, b) =>
          new Date(a.date || 0).getTime() - new Date(b.date || 0).getTime(),
        sortDirections: ['descend' as const, 'ascend' as const],
        render: (text) =>
          text ? new Date(text).toLocaleDateString('en-GB') : '-',
      },
    {
      title:"Operation",
      dataIndex:"operation",
       sorter: (a, b) => a.operation?.localeCompare(b.operation),
           sortDirections: ['descend', 'ascend'],
            ...getColumnSearchProps('operation')
    },
    {
      title:"Previous Operation",
      dataIndex:"prevOperation",
             sorter: (a, b) => a.prevOperation?.localeCompare(b.prevOperation),
           sortDirections: ['descend', 'ascend'],
            ...getColumnSearchProps('prevOperation')
    },
    {
      title:"Lot Number",
      dataIndex:"lotNumber",
             sorter: (a, b) => a.lotNumber?.localeCompare(b.lotNumber),
           sortDirections: ['descend', 'ascend'],
            ...getColumnSearchProps('lotNumber')
    },
    {
      title:"Lot Name",
      dataIndex:"lotVariant",
             sorter: (a, b) => a.lotVariant?.localeCompare(b.lotVariant),
           sortDirections: ['descend', 'ascend'],
            ...getColumnSearchProps('lotVariant')
    },
    {
      title:"Input Qty",
      dataIndex:"inputQuantity",
      render: (value) => Number(Number(value).toFixed(2))
    },
    {
      title:"Product",
      dataIndex:"product",
       sorter: (a, b) => a.product?.localeCompare(b.product),
           sortDirections: ['descend', 'ascend'],
            ...getColumnSearchProps('product')
    },
    {
      title:"Count",
      dataIndex:"count"
    },
    {
      title:"Remarks",
      dataIndex:"remarks",
       sorter: (a, b) => a.lotVariant?.localeCompare(b.lotVariant),
           sortDirections: ['descend', 'ascend'],
            ...getColumnSearchProps('lotVariant')
    },
    {
      title:"Ex.Factory Date",
      dataIndex:"exFctoryDate",
      sorter: (a, b) =>
          new Date(a.exFctoryDate || 0).getTime() - new Date(b.exFctoryDate || 0).getTime(),
        sortDirections: ['descend' as const, 'ascend' as const],
        render: (text) =>
          text ? new Date(text).toLocaleDateString('en-GB') : '-',
    },
    {
      title:"Priority",
      dataIndex:"priority"
    },
    // {
    //   title:"Output Qty",
    //   dataIndex:""
    // },
        {
      title:"Action",
      render: (_, record) => (
            <ArrowRightOutlined
              style={{ fontSize: '18px', cursor: 'pointer', color: '#1890ff' }}
              onClick={() => openModal(record)}
            />
          )
    },
  ]

      const handleFilterSubmit = (values) => {
        getProdOpInputData();
     }

     const filterResetHandler=()=>{
      filterForm.resetFields()
      getProdOpInputData();
     }

     const onOutputProductChange = (productId) => {
  form.setFieldsValue({ outputProduct: productId });
  getCountsByProduct(productId);
};
const getCountsByProduct = (productId) => {
  if (!productId) {
    setFilteredCounts([]);
    return;
  }

  rmservice.getAllProductCount().then(res => {
    if (res.status) {

      const filtered = res.data;

      setFilteredCounts(res.data);

      if (filtered.length === 1) {
        form.setFieldsValue({ count: filtered[0].id });
      } else {
        form.setFieldsValue({ count: undefined });
      }

    } else {
      setFilteredCounts([]);
    }
  });
};

  return (
      <Card  title={<span style={{ color: 'white' }}>Operation Reporting</span>} style={{ textAlign: 'center' }} headStyle={{ backgroundColor: '#69c0ff', border: 0 }}
              extra={<span><Button> <Link to="/prod-operations-form">Create</Link></Button> </span>}>
                <Form form={filterForm}  onFinish={handleFilterSubmit} layout='vertical'>
                 <Row gutter={12}>
                 <Col span={5}>
                     <Form.Item label={'Operation'} name='filterOperation' >
                                           <Select allowClear showSearch optionFilterProp='children' placeholder='Select  Operation'>
                                             {
                                               operation.map(e => {
                                                 return(
                                                   <Option key={e.operation} value={e.operation}>{e.operation}</Option>
                                                 )
                                               })
                                             }
                                           </Select>
                                         </Form.Item>
                     </Col>
                      <Col span={8}>
                     <Form.Item label={'Previous Operation'} name='filterPrevOperation' >
                                           <Select allowClear showSearch optionFilterProp='children' placeholder='Select Previous Operation'>
                                             {
                                               prevOperation.map(e => {
                                                 return(
                                                   <Option key={e.prevOperation} value={e.prevOperation}>{e.prevOperation}</Option>
                                                 )
                                               })
                                             }
                                           </Select>
                                         </Form.Item>
                     </Col>
                     <Col span={5}>
                     <Form.Item label={'Lot Number'} name='filterLotNumber' >
                                           <Select allowClear showSearch optionFilterProp='children' placeholder='Select Lot Number'>
                                             {
                                               lotNumber.map(e => {
                                                 return(
                                                   <Option key={e.lotNumber} value={e.lotNumber}>{e.lotNumber}</Option>
                                                 )
                                               })
                                             }
                                           </Select>
                                         </Form.Item>
                     </Col>
                     <Col style={{paddingTop:"16px"}}>
                      <Button type="primary" htmlType="submit">
                        Submit
                      </Button>
                    </Col>
                    <Col style={{paddingTop:"16px"}}>
                      <Button danger onClick={filterResetHandler}>
                        Reset
                      </Button>
                    </Col>
                 </Row>
                </Form>
        <Table columns={Columns} dataSource={prodOpInputData}/>
        <Modal
                visible={modalVisible}
                onCancel={() => setModalVisible(false)}
                footer={null}
                width={900}
                title="Output Reporting"
              >
        
                <div style={{ marginBottom: 20, background: '#fafafa', padding: 15, borderRadius: 6 }}>
                  <Row gutter={16}>
                    <Col span={6}><b>Lot No:</b> {selectedRow?.lotNumber}</Col>
                    {/* <Col span={6}><b>Lot Name:</b> {selectedRow?.lotName || '-'}</Col> */}
                    <Col span={6}><b>Input Qty:</b> {Number(Number(selectedRow?.inputQuantity).toFixed(2))}</Col>
                     <Col span={6}><b>O/P Reported Qty:</b> {Number(Number(selectedRow?.outputReportedQty).toFixed(2))}</Col>
                     <Col span={6}><b>Remaining Qty:</b> {Number(Number(selectedRow?.balanceQty).toFixed(2))}</Col>

                  </Row>
        
                  <Row gutter={16} style={{ marginTop: 10 }}>

                    <Col span={6}><b>Input Product:</b> {selectedRow?.product || '-'}</Col>
        
                    {(selectedRow?.count && selectedRow.count !== 0) && (
                      <Col span={6}><b>Count:</b> {selectedRow?.count}</Col>
                    )}
                    {(selectedRow?.countType && selectedRow.countType !== 0) && (
                      <Col span={6}><b>Count Type:</b> {selectedRow?.countType}</Col>
                    )}
                  </Row>
                </div>
        
                <Form form={form} layout="vertical">
        
                  <Row gutter={16}>
                    <Col span={6}>
                      <Form.Item
                        label="Date"
                        name="date"
                        rules={[{ required: true, message: 'Date is required' }]}
                      >
                        <DatePicker style={{ width: '100%' }} />
                      </Form.Item>
                    </Col>
                    <Col span={6}>
                      <Form.Item label="Operation">
                        <Input value={selectedRow?.operation} disabled />
                      </Form.Item>
                    </Col>
        
                    <Col span={6}>
                      <Form.Item
                        label="Quantity"
                        name="quantity"
                        rules={[{ required: true }]}
                      >
                        <Input
                          type="number"
                          onChange={() =>
                            form.setFieldsValue({ yield: calculateYield() })
                          }
                        />
                      </Form.Item>
                    </Col>
        
                    <Col span={6}>
                      <Form.Item
                        label="Output Product"
                        name="outputProduct"
                        rules={[{ required: true }]}
                      >
                        <Select
                        
                          showSearch
                          placeholder="Select Product"
                          optionFilterProp="children"
                          onChange={(value) => onOutputProductChange(value)}
                          
                        >
                          {
                              variants.map(e => {
                                return(
                                  <Option key={e.skuCodeId} value={e.skuCodeId}>{e.shortCode}</Option>
                                )
                              })
                            }
                        </Select>
                      </Form.Item>
                    </Col>
                    {OUTPUT_OPERATION_FIELDS[selectedRow?.operation?.toUpperCase()]?.map((field) => {
  if (field.name === 'countType') {
    return (
      <Col span={6} key="countType">
        <Form.Item
          label="Count Type"
          name="countType"
          rules={[{ required: true, message: 'Count Type is required' }]}
        >
          <Select placeholder="Select Count Type">
            {Object.values(countTypeEnum).map(val => (
              <Option key={val} value={val}>{val}</Option>
            ))}
          </Select>
        </Form.Item>
      </Col>
    );
  }

  if (field.name === 'count') {
    return (
      <Col span={6} key="count">
        <Form.Item
          label="Count"
          name="count"
          rules={[{ required: true, message: 'Count is required' }]}
        >
          <Select
            showSearch
            placeholder="Select Count"
            optionFilterProp="children"
          >
            {
                              filteredCounts.map(e => {
                                return(
                                  <Option key={e.count} value={e.count}>{e.count}</Option>
                                )
                              })
                            }
          </Select>
        </Form.Item>
      </Col>
    );
  }

  return null;
})}
                    <Col span={6}>
                      <Form.Item
                        label="Reporting Type"
                        name="reportingType"
                        rules={[{ required: true }]}
                      >
                        <Select showSearch>
                         {Object.values(DeheadingReportingTypeEnum).map(val => (
                                   <Option key={val} value={val}>
                                     {val}
                                   </Option>
                                 ))}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col span={6}>
                      <Form.Item label="Yield" name="yield">
                        <Input disabled />
                      </Form.Item>
                    </Col>
                    <Col>
                      <Button
  type="primary"
  icon={<PlusOutlined />}
  onClick={onAddOutputData}
>
  {editIndex !== null ? 'Update' : 'Add'}
</Button>
                    </Col>
                    <Col>
                      <Button danger onClick={() => form.resetFields()}>
                        Reset
                      </Button>
                    </Col>
                  </Row>
        <Row style={{ marginTop: 20 }}>
  <Col span={24}>
    <Table
      bordered
      size="small"
      columns={outputColumns}
      dataSource={outputGridData}
      pagination={false}
      rowKey={(_, index) => index.toString()}
    />
  </Col>
</Row>

<Row justify="end" style={{ marginTop: 20 }}>
  <Col>
    <Button
  type="primary"
  disabled={outputGridData.length === 0}
  onClick={() => handleSubmit(form.getFieldsValue())}
>
  Submit
</Button>
  </Col>
</Row>
                  {/* <Row gutter={16}>
                    
                  </Row> */}
                </Form>
              </Modal>
      </Card>
    )
}

export default SpsaProductionOperationsGrid